import { NetworkStatus } from '@cbridge-utils/network';
import { ISupersetStore } from './superset.interface';

const DEFAULT_REPORT_EXPORT_ROW_LIMIT = 300000;

/**
 * Rows a CSV export may carry. Superset silently caps `row_limit` at its `SQL_MAX_ROW`, so the
 * value follows the environment (`VITE_REPORT_EXPORT_ROW_LIMIT`); an export above it is announced
 * as truncated (LB-4553).
 */
export const REPORT_EXPORT_ROW_LIMIT =
  Number(import.meta.env['VITE_REPORT_EXPORT_ROW_LIMIT']) || DEFAULT_REPORT_EXPORT_ROW_LIMIT;

export const supersetInitialState: ISupersetStore = {
  chartList: {
    items: [],
    networkStatus: NetworkStatus.None,
  },
  chartMetadata: {},
};
